import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllResupplySettingsService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    return axios.get(
      `${api}/ReSupplySettings/GetReSupplyPagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchDrugTypeService = async (access_token) => {
  try {
    return axios.get(`${api}/ReSupplySettings/GetDrugTypeLoadingData`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const addResupplyManagementService = async (access_token, data) => {
  try {
    return axios.post(`${api}/ReSupplySettings/AddReSupplySetting`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchResupplySettingsByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/ReSupplySettings/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateResupplyManagementService = async (
  access_token,
  data,
  id
) => {
  try {
    return axios.post(
      `${api}/ReSupplySettings/UpdateReSupplySetting?Id=${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};
